<template>
  <div class="side-menu-v3__item-content mgt-md">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 58%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 65%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 55%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 62%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 52%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 65%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 55%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 62%" />
  </div>
  <div class="side-menu-v3__item-content">
    <zm-skeleton-item variant="text" class="side-menu-v3__item-icon" style="width: 20px" />
    <zm-skeleton-item variant="text" style="width: 52%" />
  </div>
</template>

<script setup>
import { ZmSkeletonItem } from '@zoom/zoom-ui-vue3'
</script>
